import { Space, Tag } from "antd";
import type { AIHighlight } from "./types";

interface FindingsBadgesProps {
  highlights: AIHighlight[];
}

const severityConfig = {
  critical: { color: "red", label: "критических" },
  warning: { color: "orange", label: "предупреждений" },
  info: { color: "blue", label: "информационных" },
  ok: { color: "green", label: "норма" },
} as const;

export const FindingsBadges: React.FC<FindingsBadgesProps> = ({ highlights }) => {
  const counts = highlights.reduce<Record<string, number>>((acc, h) => {
    acc[h.severity] = (acc[h.severity] ?? 0) + 1;
    return acc;
  }, {});

  return (
    <Space wrap size={4}>
      {(Object.keys(severityConfig) as Array<keyof typeof severityConfig>).map((severity) => {
        const count = counts[severity];
        if (!count) return null;
        const cfg = severityConfig[severity];
        return (
          <Tag key={severity} color={cfg.color}>
            {count} {cfg.label}
          </Tag>
        );
      })}
    </Space>
  );
};
